module.exports = __webpack_public_path__ + "img/bq.9618efee.svg";